import React from 'react';
import { Link } from 'react-router-dom';
import { resolveUploadUrl } from '../config/api';
import { useLanguage } from '../context/LanguageContext';
import './NewsCard.css';

const NewsCard = ({ news }) => {
  const { t } = useLanguage();
  // Function to decode HTML entities
  const decodeHtmlEntities = (text) => {
    if (!text) return '';
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  };

  // Function to strip HTML tags from text
  const stripHtmlTags = (html) => {
    if (!html) return '';
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';
    // Decode any remaining HTML entities
    return decodeHtmlEntities(text);
  };

  // Clean the title and excerpt by removing HTML tags and decoding entities
  const cleanTitle = stripHtmlTags(news.title);
  const cleanExcerpt = stripHtmlTags(news.excerpt);

  // Check if this is a local news (created by admin)
  const isLocalNews = news.isLocal;

  const getImageUrl = () => {
    if (!news.imageUrl) return null;
    if (news.imageUrl.startsWith('http')) return news.imageUrl;
    return resolveUploadUrl(news.imageUrl);
  };

  return (
    <div className="news-card">
      {news.imageUrl && (
        <div className="news-image">
          <img src={getImageUrl()} alt={cleanTitle} />
        </div>
      )}
      <div className="news-content">
        <h3>{cleanTitle}</h3>
        <p className="news-excerpt">{cleanExcerpt}</p>
        <div className="news-footer">
          {!isLocalNews && <span className="news-source">{news.source}</span>}
          {isLocalNews ? (
            <Link 
              to={`/news/${news._id}`}
              className="news-link"
            >
              {t('newsCard.readArticle')}
            </Link>
          ) : (
            <a 
              href={news.externalLink || '#'} 
              target="_blank" 
              rel="noopener noreferrer"
              className="news-link"
            >
              {t('newsCard.readArticle')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsCard;


